import { BrowserRouter } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import { Analytics } from '@vercel/analytics/react';

import { About, Contact, Experience, Feedbacks, Hero, Navbar, Tech, Works, StarsCanvas, SocialIcons } from "./components";

const App = () => {
  return (
    <BrowserRouter>
      <div className='relative z-0 bg-primary'>
        <Toaster
          position="top-center"
          containerStyle={{
            position: 'fixed',
            top: '80px',
            left: 0,
            right: 0,
            zIndex: 10000,
          }}
          toastOptions={{
            style: {
              background: '#1e1e1e',
              color: '#fff',
              padding: '12px 20px',
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              border: '1px solid #333',
              zIndex: 10000,
              position: 'relative',
            },
            success: {
              style: {
                border: '1px solid #52c41a',
                color: '#52c41a',
                zIndex: 10000,
              },
              iconTheme: {
                primary: '#52c41a',
                secondary: '#fff',
              },
            },
            error: {
              style: {
                border: '1px solid #ff4d4f',
                color: '#ff4d4f',
                zIndex: 10000,
              },
              iconTheme: {
                primary: '#ff4d4f',
                secondary: '#fff',
              },
            },
            loading: {
              style: {
                border: '1px solid #1890ff',
                color: '#1890ff',
                zIndex: 10000,
              },
            },
          }}
        />
        <div className='bg-hero-pattern bg-cover bg-no-repeat bg-center'>
          <Navbar />
          <Hero />
        </div>
        <About />
        <Experience />
        <Tech />
        <Works />
        <Feedbacks />
        <div className='relative z-0'>
          <Contact />
          <StarsCanvas />
        </div>
      </div>
      <SocialIcons />
      <Analytics />
    </BrowserRouter>
  );
};

export default App;